<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 23 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M1.34375 0.34375C0.912278 0.34375 0.5625 0.693528 0.5625 1.125C0.5625 1.55647 0.912278 1.90625 1.34375 1.90625H2.78717C2.96415 1.90625 3.11901 2.02523 3.16461 2.19622L5.82892 12.1874C4.14769 12.6234 2.90625 14.1511 2.90625 15.9688C2.90625 16.4002 3.25603 16.75 3.6875 16.75H20.0938C20.5252 16.75 20.875 16.4002 20.875 15.9688C20.875 15.5373 20.5252 15.1875 20.0938 15.1875H4.60211C4.92386 14.2772 5.79202 13.625 6.8125 13.625H18.4982C18.797 13.625 19.0696 13.4546 19.2005 13.186C20.383 10.7594 21.4149 8.24586 22.2841 5.65756C22.3532 5.45163 22.3335 5.22621 22.2297 5.03541C22.1258 4.84461 21.9473 4.70565 21.7368 4.6519C16.7141 3.36919 11.4517 2.6875 6.03125 2.6875C5.65851 2.6875 5.28652 2.69072 4.91529 2.69715L4.67435 1.79362C4.44635 0.938633 3.67203 0.34375 2.78717 0.34375H1.34375Z"
                :fill="color" 
            />
            <path
                d="M2.90625 19.0938C2.90625 18.2308 3.60581 17.5312 4.46875 17.5312C5.3317 17.5312 6.03125 18.2308 6.03125 19.0938C6.03125 19.9567 5.3317 20.6562 4.46875 20.6562C3.60581 20.6562 2.90625 19.9567 2.90625 19.0938Z"
                :fill="color" 
            />
            <path
                d="M16.1875 19.0938C16.1875 18.2308 16.8871 17.5312 17.75 17.5312C18.6129 17.5312 19.3125 18.2308 19.3125 19.0938C19.3125 19.9567 18.6129 20.6562 17.75 20.6562C16.8871 20.6562 16.1875 19.9567 16.1875 19.0938Z"
                :fill="color" 
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgCart',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>